import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logow.png'


const _withScopeId = n => (_pushScopeId("data-v-2dd6c62e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btm" }
const _hoisted_2 = { class: "tail column" }
const _hoisted_3 = { class: "tail-item" }
const _hoisted_4 = { class: "tail-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "t-row h1_white align footer-bold",
  id: "font-size",
  style: {"cursor":"default"}
}, " Products ", -1))
const _hoisted_6 = { class: "tail-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "t-row h1_white align footer-bold",
  id: "font-size",
  style: {"cursor":"default"}
}, " Information ", -1))
const _hoisted_8 = { class: "tail-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "t-row h1_white align footer-bold",
  id: "font-size",
  style: {"cursor":"default"}
}, " Follow Us ", -1))
const _hoisted_10 = { class: "t-row flex flc align" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_r_button = _resolveComponent("r-button")!
  const _component_r_icon = _resolveComponent("r-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "t-row logo",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotolink('/'))),
          src: _imports_0
        }),
        _createVNode(_component_r_button, {
          class: "mm20",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gotolink('/contact'))),
          type: "second",
          id: "font-size"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Contact Us")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gotolink('/merchant'))),
          class: "t-row h1_white align footer-opacity",
          id: "font-size"
        }, " Roxe Pay "),
        _createElementVNode("div", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.gotolink('/roxe-one'))),
          class: "t-row h1_white align footer-opacity",
          id: "font-size"
        }, " Roxe One "),
        _createElementVNode("div", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.gotolink('/risn'))),
          class: "t-row h1_white align footer-opacity",
          id: "font-size"
        }, " RISN ")
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.gotolink('/about-us'))),
          class: "t-row h1_white align footer-opacity",
          id: "font-size"
        }, " About Us "),
        _createElementVNode("div", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.gotolink('/FAQ'))),
          class: "t-row h1_white align footer-opacity",
          id: "font-size"
        }, " FAQs "),
        _createElementVNode("div", {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.gotolink('/legal-and-privacy'))),
          class: "t-row h1_white footer-opacity",
          id: "font-size"
        }, " Legal & Privacy ")
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_r_icon, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.gotolink('https://twitter.com/getroxe', true))),
            class: "mr15",
            width: _ctx.calsize(20),
            height: _ctx.calsize(20),
            icon: "tw"
          }, null, 8, ["width", "height"]),
          _createVNode(_component_r_icon, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.gotolink(' https://www.facebook.com/getroxe', true))),
            class: "mr15",
            width: _ctx.calsize(20),
            height: _ctx.calsize(20),
            icon: "face"
          }, null, 8, ["width", "height"]),
          _createVNode(_component_r_icon, {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.gotolink('https://instagram.com/getroxe', true))),
            class: "mr15",
            width: _ctx.calsize(20),
            height: _ctx.calsize(20),
            icon: "in"
          }, null, 8, ["width", "height"]),
          _createVNode(_component_r_icon, {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.gotolink(' https://www.linkedin.com/company/roxe-network', true))),
            class: "mr15",
            width: _ctx.calsize(20),
            height: _ctx.calsize(20),
            icon: "linkin"
          }, null, 8, ["width", "height"]),
          _createVNode(_component_r_icon, {
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.gotolink('https://tiktok.com/@getroxe', true))),
            class: "mr15",
            width: _ctx.calsize(20),
            height: _ctx.calsize(20),
            icon: "TikTok"
          }, null, 8, ["width", "height"]),
          _createVNode(_component_r_icon, {
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.gotolink(' https://www.youtube.com/channel/UCGxIJ7lLOelWui96OfFDhWg', true))),
            class: "mr15",
            width: _ctx.calsize(20),
            height: _ctx.calsize(20),
            icon: "YouTube"
          }, null, 8, ["width", "height"])
        ])
      ])
    ])
  ]))
}